export const OVERLAY_SIDE_PANEL_ENTER_DURATION = 400;
export const OVERLAY_SIDE_PANEL_EXIT_DURATION = 350;
export const OVERLAY_SIDE_PANEL_EASING = 'cubic-bezier(0.16, 1, 0.3, 1)';
